import React from 'react';

export default function PromoBadge (props) {
  const { image } = props;
  return (
    <span className={`promo-badge ${props.className ? props.className : ''}`}>
      <img className='promo-badge__image'  src={image} alt="Oferta specjalna"/>
    </span>
  )
}